import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ProgramSendFaxPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-program-send-fax',
  templateUrl: 'program-send-fax.html',
})
export class ProgramSendFaxPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProgramSendFaxPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/program-send-fax/program-send-fax.ts